// Safe wrappers around the global `window.Intercom` function.
//
// The Intercom widget snippet is loaded by index.html but intentionally NOT
// by msteams.html (the MS Teams embed at teams.approveit.today). Intercom's
// widget does not work inside the Teams iframe (CSP + the widget's own
// "traffic permission settings"), so the Teams bundle ships without it.
//
// Shared React code must therefore never assume `window.Intercom` exists —
// doing so throws a ReferenceError in the Teams build. Route every call
// through `safeIntercom(...)` (no-ops when absent) and gate UI that points
// at Intercom (report buttons, "contact support" links) behind
// `isIntercomAvailable()`.

type IntercomFn = (...args: unknown[]) => unknown

const getIntercom = (): IntercomFn | undefined => {
  const fn = (window as unknown as { Intercom?: unknown }).Intercom
  return typeof fn === 'function' ? (fn as IntercomFn) : undefined
}

/** True when the Intercom widget is loaded on this page. */
export const isIntercomAvailable = (): boolean => getIntercom() !== undefined

/** Invoke Intercom if loaded; silently no-op otherwise. */
export const safeIntercom = (...args: unknown[]): void => {
  getIntercom()?.(...args)
}
